import { Platform } from '@maggie/cordova/platform';

export const useIsDevice = () => {
  // Once this is ready to roll out - we can use ?platform=ios/android in the URL
  return Platform.isCordova() || !!window.__scWebview.platform;
};
